import { useContext } from "react";
import EventContext from "./context/EventContext";
import { extractParameter } from "./utils/paramExtraction";
import { translationsGB } from "./i18n_gb";
import { translationsBS } from "./i18n_bs";

export const langResources = {
  bs: {
    translations: translationsBS,
  },
  de: {
    translations: {
      "-- Select option --": "-- Wähle eine Option --",
      "About Our Speaker": "Über unseren Sprecher",
      "add-google-calendar": "Zu Google Kalender hinzufügen",
      agenda: "Agenda",
      All: "Alle",
      "All categories": "Alle Kategorien",
      "All locations": "Alle Orte",
      "and-book": "und buchen",
      "back-to-events": "Zurück zu den Ereignissen",
      "BK Event": "BK-Ereignis",
      "book-only": "BK-Ereignis",
      "booking required": "Reservierung erforderlich",
      Centre: "Center",
      Close: "schließen",
      Conference: "Konferenz", // TODO: Needs translation
      "Contact Email": "Kontakt E-mail",
      "Copied event address to clipboard ...":
        "Ereignisadresse in die Zwischenablage kopiert ...",
      "Could not retrieve event due to an error":
        "Ereignis konnte aufgrund eines Fehlers nicht abgerufen werden",
      Course: "Kurs",
      day: "Tag",
      days: "Tage",
      description: "Beschreibung",
      "enter-search": "Suche eingeben",
      event_plural: "eventos",
      event: "Event",
      events: "Events",
      Festivals: "Festivals",
      "go-to-page": "Ir a la página",
      "Group session": "Gruppensitzung",
      hours: "Stunden",
      "Image cards": "Kartenansicht",
      "Import on Google Calendar": "In Google Kalender importieren",
      "Join Zoom meeting": "Zoom-Meeting beitreten",
      Lecture: "Vortrag",
      Meditation: "Meditation",
      minutes: "Minuten",
      Miscellaneous: "Andere",
      month: "Monat",
      month_January: "Januar",
      month_February: "Februar",
      month_March: "März",
      month_April: "April",
      month_May: "Mai",
      month_June: "Juni",
      month_July: "Juli",
      month_August: "August",
      month_September: "September",
      month_October: "Oktober",
      month_November: "November",
      month_December: "Dezember",
      "More details": "Mehr Details",
      "More informations about this event on":
        "Weitere Informationen zu dieser Veranstaltung auf",
      next: "nächste",
      "No events found": "Keine Events gefunden ...",
      "no event id": "Keine Ereignis-ID. Bitte fügen Sie der URL die Ereignis-ID (?eventId=<id>) hinzu.",
      "Nothing more to load": "Nichts mehr zu laden",
      of: "von",
      "online_state_In Person": "Vor Ort",
      online_state_Mixed: "On line und vor Ort",
      online_state_Online: "Online",
      online_state_None: "Alle Events",
      "Online activity": "Online",
      "Online State": "Online oder vor Ort",
      "Open webcast URL": "Webcast-URL öffnen",
      "other-sessions": "Andere Sitzungen",
      Overbooked: "Überbucht",
      page: "Seite",
      "Panel discussion": "Podiumsdiskussion",
      "Power and protection": "Power and protection",
      previous: "früher",
      Private: "Privat",
      "read-more": "Weiterlesen",
      Retreat: "Retreat",
      search: "Suche",
      seconds: "Sekunden",
      Seminar: "Seminar",
      "Share on Facebook": "Auf Facebook teilen",
      "Share on Twitter": "Auf Twitter teilen",
      "Share via Email": "Per E-Mail teilen",
      "Show less": "Weniger Ergebnisse",
      "Show more": "Mehr Ergebnisse",
      show: "Anzeigen",
      "Show required fields": "Pflichtfelder anzeigen",
      "Similar Events": "Ähnliche Veranstaltungen",
      "Special event": "Besondere Veranstaltung",
      Table: "Tabelle",
      "This event is no longer available.":
        "Diese Veranstaltung ist nicht mehr verfügbar.",
      Time: "Zeit",
      "To get started, edit <1>src/App.js</1> and save to reload.":
        "Para comenzar, edite <1>src/App.js</1> y guarde para recargar",
      today: "Heute",
      Training: "Ausbildung",
      "upcoming-dates": "Bevorstehende Termine",
      week: "Woche",
      weekday_FR: "FR",
      weekday_MO: "MO",
      weekday_SA: "SA",
      weekday_SU: "SO",
      weekday_TH: "DO",
      weekday_TU: "DI",
      weekday_WE: "MI",
      Workshop: "Workshop",
      "Your time": "Deine Zeit",
      "There are no more seats available for this event!":
        "Für diese Veranstaltung sind keine Plätze mehr verfügbar!",
    },
  },
  "en-GB": {
    translations: translationsGB,
  },
  "en-US": {
    translations: {
      "-- Select option --": "-- Select option --",
      "About Our Speaker": "About Our Speaker",
      "add-google-calendar": "Add to Google calendar",
      agenda: "Agenda",
      All: "All",
      "All categories": "All categories",
      "All locations": "All locations",
      "and-book": "and Register",
      "back-to-events": "Back to events",
      "BK Event": "BK Event",
      "book-only": "Register Only",
      "booking required": "booking required",
      Centre: "Center",
      Close: "Close",
      Conference: "Conference",
      "Contact Email": "Contact Email",
      "Copied event address to clipboard ...":
        "Copied event address to clipboard ...",
      "Could not retrieve event due to an error":
        "Could not retrieve event due to an error",
      Course: "Course",
      day: "Day",
      days: "Days",
      description: "Description",
      "enter-search": "Enter search ...",
      event_plural: "events",
      event: "event",
      Festivals: "Festivals",
      "go-to-page": "Go to page",
      "Group session": "Group session",
      hours: "Hours",
      "Image cards": "Image cards",
      "Import on Google Calendar": "Import on Google Calendar",
      "Join Zoom meeting": "Entrar na reunião do Zoom",
      Lecture: "Lecture",
      Meditation: "Meditation",
      minutes: "minutes",
      Miscellaneous: "Miscellaneous",
      month: "Month",
      month_January: "January",
      month_February: "February",
      month_March: "March",
      month_April: "April",
      month_May: "May",
      month_June: "June",
      month_July: "July",
      month_August: "August",
      month_September: "September",
      month_October: "October",
      month_November: "November",
      month_December: "December",
      "More details": "More details",
      "More informations about this event on":
        "More informations about this event on",
      next: "Next",
      "No events found": "No events found ...",
      "no event id": "No event id. Please add the event id (?eventId=<id>) to the URL.",
      "Nothing more to load": "Nothing more to load",
      of: "of",
      "online_state_In Person": "In Person",
      online_state_Mixed: "Online and In Person",
      online_state_None: "All events",
      online_state_Online: "Online",
      "Online activity": "Online activity",
      "Online State": "Online State",
      "Open webcast URL": "Open webcast",
      "other-sessions": "Other Sessions",
      Overbooked: "Overbooked",
      page: "Page",
      "Panel discussion": "Panel discussion",
      "Power and protection": "Power and protection",
      previous: "Previous",
      Private: "Private",
      "read-more": "Read More",
      Retreat: "Retreat",
      search: "Search",
      seconds: "seconds",
      Seminar: "Seminar",
      "Share on Facebook": "Share on Facebook",
      "Share on Twitter": "Share on Twitter",
      "Share via Email": "Share via Email",
      show: "Show",
      "Show less": "Show less",
      "Show more": "Show more",
      "Show required fields": "Show required fields",
      "Similar Events": "Similar Events",
      "Special event": "Special event",
      Table: "Table",
      "This event is no longer available.":
        "This event is no longer available.",
      Time: "Time",
      to: "to",
      "To get started, edit <1>src/App.js</1> and save to reload.":
        "To get started, edit <1>src/App.js</1> and save to reload.",
      today: "Today",
      Training: "Training",
      "upcoming-dates": "Upcoming Dates",
      week: "Week",
      weekday_FR: "FR",
      weekday_MO: "MO",
      weekday_SA: "SA",
      weekday_SU: "SU",
      weekday_TH: "TH",
      weekday_TU: "TU",
      weekday_WE: "WE",
      Workshop: "Workshop",
      "Your time": "Your time",
      "There are no more seats available for this event!":
        "There are no more seats available for this event!",
    },
  },
  es: {
    translations: {
      "-- Select option --": "-- Seleccionar opción --",
      "About Our Speaker": "Sobre nuestro orador",
      "add-google-calendar": "Agregar al calendario de Google",
      agenda: "Agenda",
      All: "Todos",
      "All categories": "Todas las categorias",
      "All locations": "All locations",
      "and-book": "y reservar",
      "back-to-events": "Volver a los eventos",
      "BK Event": "Evento BK",
      "book-only": "Solo reserva",
      "booking required": "se requiere reserva",
      Centre: "Centro",
      Close: "Cerca",
      Conference: "Conferencia",
      "Contact Email": "Email de contacto",
      "Copied event address to clipboard ...":
        "Dirección del evento copiada al portapapeles...",
      "Could not retrieve event due to an error":
        "No se pudo recuperar el evento debido a un error",
      Course: "Curso",
      day: "Dia",
      days: "Dias",
      description: "Descripción",
      "enter-search": "Ingrese la búsqueda",
      event_plural: "eventos",
      event: "evento",
      Festivals: "Festivales",
      "go-to-page": "Ir a la página",
      "Group session": "Sesión grupal",
      hours: "Horas",
      "Image cards": "Tarjetas de imagen",
      "Import on Google Calendar": "Importar en Google Calendar",
      Lecture: "Conferencia",
      Meditation: "Meditación",
      minutes: "Minutos",
      Miscellaneous: "Diversos",
      month: "Mes",
      month_January: "Enero",
      month_February: "Febrero",
      month_March: "Marzo",
      month_April: "Abril",
      month_May: "Mayo",
      month_June: "Junio",
      month_July: "Julio",
      month_August: "Agosto",
      month_September: "Septiembre",
      month_October: "October",
      month_November: "Noviembre",
      month_December: "Diciembre",
      "More details": "Más detalles",
      "More informations about this event on":
        "Más información sobre este evento en",
      next: "Seguinte",
      "No events found": "No se encontraron eventos...",
      "no event id": "Sin identificación de evento. Agregue la identificación del evento (?eventId=<id>) a la URL.",
      "Nothing more to load": "Nada más para cargar",
      of: "de",
      "online_state_In Person": "En persona",
      online_state_Mixed: "En línea y en persona",
      online_state_Online: "En línea",
      online_state_None: "Todos los eventos",
      "Online activity": "Actividad en línea",
      "Online State": "Estado en línea",
      "Open webcast URL": "Abrir URL de webcast",
      "other-sessions": "Otras sesiones",
      Overbooked: "Sobre-reservado",
      page: "Página",
      "Panel discussion": "Panel de discusión",
      "Power and protection": "Power and protection",
      previous: "Anterior",
      Private: "Privado",
      "read-more": "Leer más",
      Retreat: "Retirada",
      search: "Buscar",
      seconds: "Segundos",
      Seminar: "Seminario",
      "Share on Facebook": "Compartir en Facebook",
      "Share on Twitter": "Compartir en Twitter",
      "Share via Email": "Compartir via correo electrónico",
      show: "Mostrar",
      "Show less": "Mostrar menos",
      "Show more": "Mostrar mais",
      "Show required fields": "Mostrar campos obligatorios",
      "Similar Events": "Eventos similares",
      "Special event": "Evento especial",
      Table: "Mesa",
      "This event is no longer available.":
        "Este evento ya no está disponible.",
      Time: "Hora",
      to: "a",
      "To get started, edit <1>src/App.js</1> and save to reload.":
        "Para comenzar, edite <1>src/App.js</1> y guarde para recargar",
      today: "Hoy",
      Training: "Formación",
      "upcoming-dates": "Fechas siguientes",
      week: "Semana",
      weekday_FR: "VI",
      weekday_MO: "LU",
      weekday_SA: "SA",
      weekday_SU: "DO",
      weekday_TH: "JU",
      weekday_TU: "MA",
      weekday_WE: "MI",
      Workshop: "Workshop",
      "Your time": "Hora en su País",
      "There are no more seats available for this event!":
        "¡No hay más asientos disponibles para este evento!",
    },
  },
  "pt-BR": {
    translations: {
      "-- Select option --": "-- Selecione a opção --",
      "About Our Speaker": "Sobre nosso palestrante",
      "add-google-calendar": "Adicionar ao Google Agenda",
      agenda: "Agenda",
      All: "Todos",
      "All categories": "Todas as categorias",
      "and-book": "e Inscrição",
      "back-to-events": "Voltar para os Eventos",
      "BK Event": "Event BK",
      "book-only": "Somente Inscrição",
      "booking required": "reserva necessária",
      Centre: "Escolha uma localidade",
      Close: "Fechar",
      Conference: "Conferência",
      "Contact Email": "Email de contato",
      "Copied event address to clipboard ...":
        "Endereço do evento copiado para a área de transferência...",
      "Could not retrieve event due to an error":
        "Não foi possível encontrar o evento devido a um erro",
      Course: "Curso",
      day: "Dia",
      days: "Dias",
      description: "Descrição",
      "enter-search": "Pesquisar ...",
      event_plural: "eventos",
      event: "evento",
      Festivals: "Festivais",
      "go-to-page": "Ir para a página",
      "Group session": "Sessão em grupo",
      hours: "Horas",
      "Image cards": "Cartões de imagem",
      "Import on Google Calendar": "Importar no Google Calendar",
      Lecture: "Palestra",
      Meditation: "Meditação",
      minutes: "Minutos",
      Miscellaneous: "Outros",
      month: "Mês",
      month_January: "Janeiro",
      month_February: "Fevereiro",
      month_March: "Março",
      month_April: "Abril",
      month_May: "Maio",
      month_June: "Junho",
      month_July: "Julho",
      month_August: "Agosto",
      month_September: "Setembro",
      month_October: "Outubro",
      month_November: "Novembro",
      month_December: "Dezembro",
      "More informations about this event on":
        "Mais informações sobre este evento em",
      next: "Seguinte",
      "No events found": "Nenhum evento encontrado...",
      "no event id": "Nenhum ID de evento. Adicione o ID do evento (?eventId=<id>) ao URL.",
      "Nothing more to load": "Nada mais para carregar",
      of: "de",
      "online_state_In Person": "Em pessoa",
      online_state_Mixed: "Online e em pessoa",
      online_state_Online: "Online",
      online_state_None: "Todos os eventos",
      "Online activity": "Atividade Online",
      "Online State": "Online - em pessoa",
      "Open webcast URL": "Acessar a transmissão",
      "other-sessions": "Outras sessões",
      page: "Página",
      "Panel discussion": "Painel",
      "Power and protection": "Poder e proteção",
      previous: "Anterior",
      Private: "Privado",
      "read-more": "Leia Mais",
      Retreat: "Retiro",
      search: "Pesquisa",
      seconds: "Segundos",
      Seminar: "Seminário",
      "Share on Facebook": "Compartilhar no Facebook",
      "Share on Twitter": "Compartilhar no Twitter",
      "Share via Email": "Compartilhar por e-mail",
      show: "Mostrar",
      "Show less": "Mostrar menos",
      "Show more": "Mostrar mais",
      "Show required fields": "Mostrar campos obrigatórios",
      "Similar Events": "Eventos semelhantes",
      "Special event": "Evento Especial",
      Table: "Tabela",
      to: "a",
      "To get started, edit <1>src/App.js</1> and save to reload.":
        "Para começar, edite <1>src/App.js</1> e salve para recarregar.",
      today: "Hoje",
      "This event is no longer available.":
        "Este evento não está mais disponível.",
      Time: "Hora",
      Training: "Treinamento",
      "upcoming-dates": "Próximas Datas",
      week: "Semana",
      weekday_FR: "SE",
      weekday_MO: "SE",
      weekday_SA: "SA",
      weekday_SU: "DO",
      weekday_TH: "QU",
      weekday_TU: "TE",
      weekday_WE: "QU",
      Workshop: "Workshop",
      "Your time": "Seu tempo",
      "There are no more seats available for this event!":
        "Não há mais lugares disponíveis para este evento!",
    },
  },
};

export function useTranslation() {
  const eventContext = useContext(EventContext);

  const props = { ...eventContext };
  const langCode = extractParameter(props, "language", "en-US");

  return {
    t: function (key, extraObj) {
      if (arguments.length === 1) {
        return langResources[langCode].translations[key] || key;
      } else {
        // TODO: handle the extra object
        return langResources[langCode].translations[`${key}_plural`] || key;
      }
    },
    langCode,
  };
}
